import { ApplicationController } from "../application_controller"

export default class extends ApplicationController {
	static targets = [ 'switcher' ]

	toggleSwitcher(event) {
		event.preventDefault()
		$(this.switcherTarget).toggleClass('active')
	}
}